import { RemoteGetAllArchivedGroups } from 'data/usecases';
import { GetAllArchivedGroupsUseCaseInterface } from 'domain/usecases';
import { makeApiUrlArchivedGroups } from 'main/factories/http/api-url-factory';
import { makeAxiosHttpClient } from 'main/factories/http/axios-http-client-factory';

export const makeGetAllArchivedGroups =
  (): GetAllArchivedGroupsUseCaseInterface =>
    new RemoteGetAllArchivedGroups(
      makeApiUrlArchivedGroups(),
      makeAxiosHttpClient(),
    );
